import React, { useEffect, useState } from 'react';
import supabase from '../supabaseClient';
import { useAuth } from '../context/AuthContext';
// --- HINZUGEFÜGT: CSS-Modul importieren ---
import styles from '../style/Avatar.module.css';

/**
 * Eine Komponente zum Hochladen und Anzeigen von Benutzer-Avataren.
 * @param {string} url - Der aktuelle Pfad zum Avatar-Bild im Storage.
 * @param {function(string): void} onUpload - Callback-Funktion, die den neuen Bildpfad nach dem Upload zurückgibt.
 * @param {function(): void} onRemove - NEU: Callback-Funktion zum Entfernen des Avatars.
 */
function Avatar({ url, onUpload, onRemove }) { // <-- NEUE PROP HINZUGEFÜGT
  const { user } = useAuth();
  const [avatarUrl, setAvatarUrl] = useState(null);
  const [uploading, setUploading] = useState(false);

  // Effekt zum Herunterladen des Bildes, wenn sich die URL ändert
  useEffect(() => {
    if (url) {
      downloadImage(url);
    } else {
      setAvatarUrl(null); // NEU: Leert das Bild, wenn die URL null ist
    }
  }, [url]); // Hängt jetzt von 'url' ab

  const downloadImage = async (path) => {
    try {
      const { data, error } = await supabase.storage
        .from('avatars')
        .download(path);
      if (error) throw error;
      const url = URL.createObjectURL(data);
      setAvatarUrl(url);
    } catch (error) {
      console.error('Error downloading image: ', error.message);
    }
  };

  const uploadAvatar = async (event) => {
    if (!event.target.files || event.target.files.length === 0) {
      return;
    }

    if (!user) {
      alert("Sie müssen angemeldet sein, um einen Avatar hochzuladen.");
      return;
    }

    setUploading(true);
    const file = event.target.files[0];
    const fileExt = file.name.split('.').pop();
    // Eindeutiger Pfad: {userId}/avatar.{ext}
    const filePath = `${user.id}/avatar.${fileExt}`; 

    try {
      // 'upsert: true' überschreibt eine vorhandene Datei
      const { error: uploadError } = await supabase.storage
        .from('avatars')
        .upload(filePath, file, { upsert: true });

      if (uploadError) throw uploadError;

      // Rufen Sie das onUpload-Callback mit dem *Pfad* auf, nicht mit der öffentlichen URL
      onUpload(filePath); 
    } catch (error) {
      console.error('Error uploading avatar:', error.message);
      alert('Fehler beim Hochladen des Avatars.');
    } finally {
      setUploading(false);
    }
  };

  // --- MODIFIZIERT: Alle 'style' Attribute entfernt und 'className' verwendet ---
  return (
    <div className={styles.avatarContainer}>
      {avatarUrl ? (
        <img
          src={avatarUrl}
          alt="Avatar"
          className={styles.avatarImage}
        />
      ) : (
        <div className={styles.avatarPlaceholder}>
          Kein Bild
        </div>
      )}
      
      {/* --- MODIFIZIERTER BEREICH --- */}
      <div className={styles.controlsContainer}>
        <label 
          htmlFor="avatar-upload" 
          className={styles.uploadLabel}
        >
          {uploading ? 'Wird hochgeladen...' : 'Bild ändern'}
        </label>

        {/* NEUER "ENTFERNEN"-BUTTON */}
        {avatarUrl && onRemove && (
          <button
            type="button"
            className={styles.removeButton}
            onClick={onRemove}
            disabled={uploading}
          >
            Entfernen
          </button>
        )}
      </div>

      <input
        className={styles.uploadInput}
        type="file"
        id="avatar-upload"
        accept="image/*"
        onChange={uploadAvatar}
        disabled={uploading}
      />
      {/* --- ENDE DES MODIFIZIERTEN BEREICHS --- */}
    </div>
  );
}

export default Avatar;